var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
        _vm.elementTypeQuestion != 'select' && _vm.elementTypeQuestion != 'orderedChoices'
    )?_c('vue-base64-file-upload',{staticClass:"upload_wrapper_answer",attrs:{"accept":"image/png, image/jpeg","image-class":"upload_imagepreview","input-class":"upload_imageinput","disable-preview":true,"max-size":_vm.customImageMaxSize},on:{"size-exceeded":_vm.onSizeExceeded,"file":_vm.onFile,"load":_vm.onLoad}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-502bd65b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/components/ButtonImageAnswer.vue
// module id = null
// module chunks = 